import axios from 'axios';
import Cookies from 'js-cookie';

const baseURL = import.meta.env.VITE_API_URL;
const axiosInstanceF = axios.create({
	baseURL,
	headers: { 'Content-Type': 'multipart/form-data' },
});
const token = Cookies.get('bdKey');

function auth() {
	async function signIn(data) {
		const method = 'post';
		const url = `${baseURL}api/auth/login/`;
		const response = await axiosInstanceF({
			method,
			url,
			data,
		});
		return response;
	}
	async function refreshToken(refresh) {
		const headers = {
			'Content-Type': 'application/json',
		};
		const response = await axios.post(`${baseURL}api/auth/token/refresh/`, { refresh }, { headers });
		return response;
	}
	async function signOut(data) {
		const method = 'post';
		const url = `${baseURL}api/auth/logout/`;
		const response = await axios({
			method,
			baseURL: url,
			data,
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return response;
	}

	return {
		signIn,
		signOut,
		refreshToken,
	};
}

export default auth;
